export const CARD_TYPES = {
  FEATURED_PRESS: 'featured-press',
  RECENT_PRESS: 'recent-press',
  ARTICLE: 'article',
  RECENT_NEWS: 'recent-news',
  CASE_STUDY: 'case-study',
  SOLUTIONS: 'solutions',
  PRESS_PREVIEW: 'press-preview',
  TOOL: 'tool',
  FEATURED_TOOL: 'featured-tool',
  FEATURED_PRODUCT: 'featured-product',
};
